import { render, staticRenderFns } from "./DPZ.vue?vue&type=template&id=1da5c768&scoped=true"
import script from "./DPZ.vue?vue&type=script&lang=js"
export * from "./DPZ.vue?vue&type=script&lang=js"
import style0 from "./DPZ.vue?vue&type=style&index=0&id=1da5c768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5c768",
  null
  
)

export default component.exports